import React from "react";

import "./StatisticsPage.scss";

const ClicksCampaignsElement = (props) => {

  const getCampaignName = () => {
    const campaign = props.campaigns.find(item => item.id === props.campaign.id);
    return campaign ? campaign.display_name : "---";
  }

  // Elemente aus Clicks in einzelne DIVs einfügen
  const cellsHTML = props.campaign.clicks.map((item, index) => {
    return <div key={index}>{item}</div>;
  });

  return (
    <div className={'clicks-campaigns__element'}>
      <div>
        {getCampaignName()}
      </div>
      {cellsHTML}
    </div>
  );
}

export default ClicksCampaignsElement;